export const KNOWN_SITES = [
  'xing',
  'lebenslauf',
  'xing-login',
  'demo',
  'router-demo',
] as const;
export type Site = (typeof KNOWN_SITES)[number];

export function detectSite({
  entryPoint,
}: {
  entryPoint: string;
}): Site | undefined {
  if (entryPoint === '@xing-com/crate-communication-root') return 'xing';
  if (entryPoint === '@xing-com/crate-login-root') return 'xing-login';
  if (
    entryPoint === '@xing-com/crate-lebenslauf-root' ||
    entryPoint === '@xing-com/crate-lebenslauf-anschreiben'
  ) {
    return 'lebenslauf';
  }
  if (entryPoint === '@xing-com/crate-demo-entry') return 'demo';
  if (entryPoint === '@xing-com/crate-router-demo-entry') return 'router-demo';

  return undefined;
}
